import { render, staticRenderFns } from "./userRoles.vue?vue&type=template&id=a46b5a14&scoped=true&"
import script from "./userRoles.vue?vue&type=script&lang=js&"
export * from "./userRoles.vue?vue&type=script&lang=js&"
import style0 from "./userRoles.vue?vue&type=style&index=0&id=a46b5a14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46b5a14",
  null
  
)

export default component.exports